<template>
  <ul class="max-w-md space-y-1 list-inside text-gray-500 tracking-wider" :key="lessonActivated">
    <li
      class="flex items-center"
      v-for="(item, index) in lessons"
      :key="index"
      :aria-current="isActive(item?.id) ? 'true' : undefined"
    >
      <!-- status icon -->
      <component
        :is="iconFor(lessonStatus(item?.id))"
        class="w-4 h-4 -ml-0.5 me-2 shrink-0"
        :class="iconTint(item?.id, lessonStatus(item?.id))"
      />

      <!-- título da aula -->
      <p
        class="cursor-pointer text-start hover:text-white"
        :class="titleClass(item?.id, lessonStatus(item?.id))"
        @click="setCurrentLessonActivated(item)"
      >
        {{ item.title }}
      </p>
    </li>
  </ul>
</template>

<script setup>
import { dataShared } from "@/shared/store";
import { dataProgress } from "@/shared/store/progress";
import { PhCheckCircle, PhCircle, PhClock, PhXCircle } from "@phosphor-icons/vue";
import { computed } from "vue";
import { defineProps } from "vue";

defineProps({
  lessons: [Array, Object],
});

const moduleActivated = computed(() => dataShared.getters.getActivatedModule);
const lessonActivated = computed(() => dataShared.getters.getActivatedLesson);

// status por lição, vindo do progress store
const lessonStatus = (id) => dataProgress.getters.lessonStatusById(id);
const isActive = (id) => String(lessonActivated.value?.id ?? "") === String(id ?? "");

// ícone por status
const iconFor = (st) =>
  ({
    not_started: PhCircle,
    in_progress: PhClock,
    passed: PhCheckCircle,
    failed: PhXCircle,
  }[st] || PhCircle);

// cor por status (fallback)
const iconClass = (st) =>
  ({
    not_started: "text-gray-400",
    in_progress: "text-orange-300",
    passed: "text-green-400",
    failed: "text-red-400",
  }[st] || "text-gray-400");

// ícone branco quando ativo; senão, cor por status
const iconTint = (id, st) => (isActive(id) ? "text-white" : iconClass(st));

// TÍTULO: regras
// - ativa: branco + leve destaque
// - not_started / in_progress: branco
// - passed: cinza 500
// - failed: vermelho
const titleClass = (id, st) => {
  if (isActive(id)) return "text-white underline font-bold";
  return (
    {
      not_started: "text-gray-500",
      in_progress: "text-gray-500",
      passed: "text-gray-500",
      failed: "text-red-400",
    }[st] || "text-white"
  );
};

function setCurrentLessonActivated(lesson) {
  dataShared.dispatch("setLessonActivated", lesson);
  dataShared.dispatch("setLiveActive", moduleActivated.value);
  dataProgress.dispatch('resetLessonResults', lesson?.id)

}
</script>
